import axios from "axios";




const sellerbaseUrl = process.env.REACT_APP_SELLER_API;
const productbaseUrl = process.env.REACT_APP_PRODUCT_API;
const orderbaseUrl = process.env.REACT_APP_ORDER_API;
// const orderbaseUrl = "http://localhost:3001";
// const sellerbaseUrl = "http://localhost:8000";

const adminbaseUrl = process.env.REACT_APP_ADMIN_API
// const adminbaseUrl = "http://192.168.31.210:4002/"

// const productbaseUrl = "http://localhost:4000/"


const sellerApi = axios.create({
    baseURL:sellerbaseUrl,
    withCredentials: true,
});
const adminApi = axios.create({
    baseURL:adminbaseUrl,
    // withCredentials: true,
});

const productApi = axios.create({
    baseURL:productbaseUrl,
    // withCredentials: true,
});
const orderApi = axios.create({
    baseURL:orderbaseUrl,
    // withCredentials: true,
});



// let sellerToken;



// if(localStorage.getItem("seller_Data") !== null){
//     const localData = JSON.parse(localStorage.getItem("seller_Data"))

//     const access_token = localData.token;

   

   

//     sellerToken = access_token;
// }


// const HeaderAuth = axios.create({
//     baseURL : sellerbaseUrl,
//     withCredentials: true,

//     headers:{
//         Authorization : `Bearer ${sellerToken}`
//     }
// })


export {sellerApi,adminApi,productApi,orderApi}